import React, { useEffect } from 'react';
import Layout from '@/common/Layout';
import HelpCenter from '@/pages/HelpCenter/components';

export const index = () => {
  useEffect(() => {
    document.title = 'Help Center - Customer Support & Assistance';
  }, []);

  return (
    <>
      <Layout sider={true}>
        <HelpCenter />
        {/* Settings Page */}
      </Layout>
    </>
  );
};
export default index;
